import { ProfileProperty } from '../types';

export function isProfileProperty(value: unknown): value is ProfileProperty {
  return typeof value === 'object' && value !== null && value.hasOwnProperty('userProperty');
}
